import { Checkbox, Radio, Stack, Tooltip, Typography } from '@mui/material';
import colors from '/@/components/theme-provider/colors';
import settings from '/@/core/settings';

export type SelectionListItemProps = {
    leftItem?: React.ReactNode;
    title: string;
    subtitle?: string;
    rightItem?: 'radio' | 'checkbox';
    isSelected?: boolean;
    disabled?: boolean;
    disabledTooltip?: string;
    onClick?: (value: number) => void;
    dataTestId?: string;
};

function SelectionListItem({
    leftItem,
    title,
    subtitle,
    rightItem,
    isSelected,
    disabled,
    disabledTooltip,
    onClick,
    dataTestId,
}: SelectionListItemProps) {
    return (
        <Tooltip title={disabled ? disabledTooltip : null} arrow>
            <Stack
                direction='row'
                p={2}
                spacing={2}
                border={`1px solid ${isSelected ? colors.themes[settings.app.theme].mui.secondary.secondary : 'lightgray'}`}
                alignItems='center'
                backgroundColor={
                    isSelected ? colors.themes[settings.app.theme].mui.primary.itemSelectedBackground : undefined
                }
                onClick={disabled ? undefined : onClick}
                sx={{
                    height: '100%',
                    ...(disabled ? {} : { cursor: 'pointer' }),
                }}
                data-testid={dataTestId}
            >
                {leftItem}
                <Stack textAlign='left' width='100%'>
                    <Typography variant='h6' color={disabled ? 'primary.mui.inactive' : 'primary'}>
                        {title}
                    </Typography>
                    <Typography variant='body2' color='primary.mui.inactive'>
                        {subtitle}
                    </Typography>
                </Stack>
                {rightItem === 'radio' && <Radio checked={isSelected} color='secondary' disabled={disabled} />}
                {rightItem === 'checkbox' && <Checkbox checked={isSelected} color='secondary' disabled={disabled} />}
            </Stack>
        </Tooltip>
    );
}

export default SelectionListItem;
